import { Popover as RP } from 'radix-ui';
import type { ReactElement, ReactNode } from 'react';
import { cx } from '../lib/cx.js';
import './overlay.css';

export interface PopoverProps {
  trigger: ReactElement;
  children: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  /** Content padding; off for menus and lists that pad their own rows. */
  padded?: boolean;
  className?: string;
  /** Accessible name for the dialog-like surface. */
  label?: string;
}

export function Popover({
  trigger,
  children,
  open,
  onOpenChange,
  side = 'bottom',
  align = 'start',
  padded = true,
  className,
  label,
}: PopoverProps) {
  return (
    <RP.Root {...(open !== undefined ? { open } : {})} {...(onOpenChange ? { onOpenChange } : {})}>
      <RP.Trigger asChild>{trigger}</RP.Trigger>
      <RP.Portal>
        <RP.Content
          className={cx('vel-float', className)}
          data-padded={padded ? '' : undefined}
          side={side}
          align={align}
          sideOffset={6}
          collisionPadding={8}
          aria-label={label}
        >
          {children}
        </RP.Content>
      </RP.Portal>
    </RP.Root>
  );
}

export const PopoverClose = RP.Close;
